import styled from '@emotion/styled';
import BuilderCard from '../../components/BuilderCard';
import Section from '../../components/Section';
import { fontWeights } from 'app/typography';
import { OutlineLabel } from 'components/Inputs/InputControl';
import Cols from 'components/Layout/Cols';
import Card from 'components/Card/Card';
import KizenTypography from 'app/kizentypo';
import BasicTable from 'components/Tables/Basic';
import CardToolbar from 'components/Layout/CardToolbar';
import {
  SizedCell as KizenSizedCell,
  SortableHeadCell as KizenSortableHeadCell,
} from 'components/Kizen/Table';
import TableScrollContainer from 'components/Tables/ScrollContainer';
import LoadingButton from 'components/Button/LoadingButton';

export const StyledBuilderCard = styled(BuilderCard)`
  padding: 0;
  max-height: 496px;
`;
export const StyledCols = styled(Cols)`
  display: grid;
  column-gap: 20px;
  grid-template-columns: minmax(0, 0.662fr) minmax(0, 0.338fr);

  & > div {
    width: 100%;
    max-width: 100%;
  }
`;
export const StyledSection = styled(Section)`
  margin-bottom: 24px;
`;
export const NoticeSection = styled(Section)`
  margin-bottom: 19px;
`;
export const MultiSelectSection = styled(Section)`
  margin-bottom: 19px;
`;
export const StyledOutlineLabel = styled(OutlineLabel)`
  margin-bottom: 10px;
  font-weight: ${fontWeights.bold};
`;

export const StyledKizenTypography = styled(KizenTypography)`
  line-height: 1;
  margin-top: 0;
  padding-bottom: 11px;
`;

export const StyledCard = styled(Card)`
  padding: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const StyledButton = styled(LoadingButton)`
  margin-top: -10px;
  margin-bottom: 18px;
  margin-right: 0;
`;

// Small alignment tweak, esp to align correctly with action button
export const SizedCell = styled(KizenSizedCell)`
  > div {
    line-height: 0;
    margin-top: 1px; // hack to force the th to 50px so the bottom border shows
  }
`;

// Small alignment tweak, esp to align correctly with action button
export const SortableHeadCell = styled(KizenSortableHeadCell)`
  > div {
    line-height: 0;
    margin-top: 1px; // hack to force the th to 50px so the bottom border shows
  }
`;
export const StyledBasicTable = styled(BasicTable)`
  thead > tr {
    height: 40px;
  }
`;
export const StyledCardToolbar = styled(CardToolbar)`
  margin-bottom: 3px;
`;
export const StyledTableScrollContainer = styled(TableScrollContainer)`
  &::-webkit-scrollbar-track:vertical {
    margin-top: 40px;
    border-top: none;
  }
`;
